import React from 'react';
import { Outlet, NavLink, Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { LayoutDashboard, MapPin, Building2, Users, Package, FileText, Database, Settings, LogOut, ExternalLink } from 'lucide-react';
import './SuperAdminLayout.css';
import { useT } from '../i18n/index';
import LanguageSwitcher from '../components/LanguageSwitcher';

const SA_NAV_KEYS = [
  { path: '/admin/dashboard', icon: LayoutDashboard, labelKey: 'nav.dashboard' },
  { path: '/admin/tenants',   icon: Building2,        labelKey: 'sa.tenants' },
  { path: '/admin/camps',     icon: MapPin,           labelKey: 'sa.camps' },
  { path: '/admin/users',     icon: Users,            labelKey: 'sa.users' },
  { path: '/admin/equipment', icon: Package,          labelKey: 'sa.equipment' },
  { path: '/admin/templates', icon: FileText,         labelKey: 'sa.templates' },
  { path: '/admin/backups',   icon: Database,         labelKey: 'sa.backups' },
  { path: '/admin/settings',  icon: Settings,         labelKey: 'sa.settings' },
];

export default function SuperAdminLayout() {
  const { user, logout } = useAuth();
  const t = useT();
  const navigate = useNavigate();

  if (!user) return <Navigate to="/admin/login" replace />;
  if (!user.isSuperadmin && !user.roles?.includes('admin')) return <Navigate to="/" replace />;

  return (
    <div className="sa-layout">
      <aside className="sa-sidebar">
        <div className="sa-sidebar-brand">
          <div className="sa-brand-icon">
            <MapPin size={24} />
          </div>
          <div>
            <div className="sa-brand-title">{t('sa.superadmin')}</div>
            <div className="sa-brand-sub">{t('sa.platform')}</div>
          </div>
        </div>

        <nav className="sa-nav">
          {SA_NAV_KEYS.map(item => {
            const Icon = item.icon;
            return (
              <NavLink key={item.path} to={item.path} className={({ isActive }) => "sa-nav-link" + (isActive ? ' active' : '')}>
                <Icon size={18} />
                <span>{t(item.labelKey)}</span>
              </NavLink>
            );
          })}
        </nav>

        <div className="sa-sidebar-footer">
          <div className="sa-user">
            <span className="sa-user-name">{user.display_name}</span>
            <span className="badge badge-gold">{t('role.superadmin')}</span>
          </div>
          <LanguageSwitcher variant="pills" />
          <button className="btn btn-ghost btn-sm" onClick={() => { logout(); navigate('/admin/login'); }}>
            <LogOut size={14} /> {t('sa.logout')}
          </button>
        </div>
      </aside>

      <div className="sa-content">
        <header className="sa-header">
          <div className="sa-header-brand">
            <Link to="/admin/dashboard" className="sa-header-logo no-print">
              <MapPin size={18} /> {t('sa.superadmin')}
            </Link>
          </div>
          <div className="sa-header-right">
            <Link to="/" className="btn btn-outline btn-sm">
              <ExternalLink size={14} /> {t('sa.to_platform')}
            </Link>
          </div>
        </header>
        <main className="sa-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
